<template>
	<div class="eia-contact-bar">
		<div class="eia-page-boundary-container">
			<div class="eia-contact-bar__contact-wrapper">
				<eia-heading level="h4">
					Other ways of finding out if EIA is required
				</eia-heading>

				<div class="contact-wrapper__contact-details">
					<div class="telephone-logo">
						<font-awesome-icon
							icon="phone-alt">
						</font-awesome-icon>
					</div>
					<eia-caption>
						Get in touch with an expert on
						<eia-link :href="telLink">{{ telephoneNumber }}</eia-link>
						or email
						<eia-link :href="mailLink">{{ emailAddress }}</eia-link>
					</eia-caption>
				</div>
			</div>

			<div class="eia-contact-bar__quod-logo">
				<a href="https://www.quod.com/"
					target="_blank">
					<quod-logo-footer></quod-logo-footer>
				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'eia-contact-bar',
	data() {
		return {
			// Note that this is the number as is displayed
			// to the user.
			//
			// The computed prop below formats it for the link.
			telephoneNumber: '0203 597 1000',
			emailAddress: 'eiascreening@quod.com',
		};
	},
	computed: {
		telLink() {
			return `tel:${this.telephoneNumber.replace( /\s/g, '' )}`;
		},
		mailLink() {
			return `mailto:${this.emailAddress}`;
		},
	},
};
</script>

<style lang="scss" scoped>
.eia-contact-bar {
	.eia-page-boundary-container {
		padding-top: 24px;
		padding-bottom: 24px;
		border-top: 1px solid $color-grey-medium;
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
	}

	&__contact-wrapper {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;

		.contact-wrapper__contact-details {
			display: grid;
			grid-template-columns: 64px 1fr;
			grid-gap: 16px;
			align-items: center;
			justify-content: flex-start;

			.telephone-logo {
				height: 64px;
				width: 64px;
				display: flex;
				align-items: center;
				justify-content: center;

				.svg-inline--fa {
					width: 3em;
					height: 3em;
				}
			}
		}
	}

	&__quod-logo {
		height: 80px;
		width: 138px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-align: center;

		a {
			display: block;
			width: 100%;
			height: 100%;
		}
	}

	@media screen and (max-width: $screen-xs) {
		.eia-page-boundary-container {
			flex-direction: column;
		}

		&__quod-logo {
			margin-top: 16px;
		}
	}
}
</style>
